"use strict"
let Promise = require("bluebird")
let crypto = require("crypto")
let randomBytes = Promise.promisify(crypto.randomBytes)
let _ = require("lodash")

const DEFAULT_NONCE_BYTES = 32
const VERSION_1 = 1

exports.sign = function (config, source, nonce) {
    if (config.version != VERSION_1) {
        throw new Error("Version " + config.version + " is not supported.")
    }

    return Promise.resolve(nonce)
        .then(function (nonce) {
            if (nonce) {
                return nonce
            }

            return randomBytes(config.nonceSize || DEFAULT_NONCE_BYTES).then(function (bytes) {
                return Date.now() + "-" + bytes.toString('hex')
            })
        })
        .then(function (nonce) {
            let string = buildString(config, source)
            string = string + nonce

            let hmac = crypto.createHmac('sha256', config.key)
            
            if (config.debug === true){
                console.warn("Signing Debugger! Key = '" + config.key + "' Nonce = '" + nonce + "' Source = '" + string + "'")
                console.log(JSON.stringify(string))
            }

            return {
                signature : hmac.update(string).digest('hex'),
                nonce : nonce
            }
        })
}

exports.verify = function (store, config, source, signature, nonce) {
    if (config.version != VERSION_1) {
        throw new Error("Version " + config.version + " is not supported.")
    }

    if (typeof signature == "object") {
        nonce = signature.nonce
        signature = signature.signature
    }

    if (config.maxAge && nonce.match(/\d+\-/)) {
        let timestamp = nonce.split("-")[0]
        timestamp = parseInt(timestamp)

        if (Math.abs(Date.now() - timestamp) > config.maxAge) {
            return Promise.resolve(false)
        }
    }

    let cacheResult = store ? store.get(nonce) : Promise.resolve(false)

    return cacheResult
        .then(function (result) {

            if (result) {
                return false
            }

            if (store) {
                store.put(nonce, Date.now())
            }

            let string = buildString(config, source)
            string = string + nonce

            let hmac = crypto.createHmac('sha256', config.key)
            let mySignature = hmac.update(string).digest('hex')
            
            var Outcome = (mySignature == signature)

            if (config.debug === true) {
                console.warn(
                    "Verify Debugger!",
                    "Key =", config.key,
                    "Nonce =", nonce,
                    "Supplied Signature =", signature,
                    "Generated Signature =", mySignature,
                    "Stringify Source =", source,
                    "String =", string,
                    "Result =", Outcome
                )
            }

            return mySignature == signature
        })
}

function buildString(config, source) {
    let string = ""
    let data = config.basePath ? _.get(source, config.basePath) : source

    if (config.fields) {
        config.fields.forEach(function (field) {
            string = string + JSON.stringify(data[field])
        })
    } else if (config.fieldPaths) {
        config.fieldPaths.forEach(function (path) {
            string += JSON.stringify(_.get(data, path))
        })
    } else if (typeof source == "string") {
        string = source
    } else {
        string = JSON.stringify(source)
    }

    return string
}

exports.SimpleMemoryStore = require("./simple-memory-store").SimpleMemoryStore
